// Constantes usadas pelo wizard de cadastro de negócio.
// Extraído para facilitar reuso e testes.

// Rotulos das 13 etapas do wizard.
export const STEP_LABELS = [
  'Básico',
  'Econômico',
  'Presença',
  'Contato',
  'Horários',
  'Local',
  'Comodidades',
  'Pagamentos',
  'Diferenciais',
  'Impacto',
  'Fotos',
  'Gestão',
  'Termos',
];

export const TOTAL_STEPS = STEP_LABELS.length;

// Mapeamento key → nome exibido dos dias da semana (usado nos horários).
export const DIAS_SEMANA = {
  segunda: 'Segunda-feira',
  terca: 'Terça-feira',
  quarta: 'Quarta-feira',
  quinta: 'Quinta-feira',
  sexta: 'Sexta-feira',
  sabado: 'Sábado',
  domingo: 'Domingo',
};
